export default function getFormData(data) {
    const params = new FormData()

    Object.keys(data).forEach(key => {
        let value = data[key]
        if (Array.isArray(value)) value = value.join(',')
        params.append(key, value)
    })

    return params
}

export const formHeader = { headers: { 'content-type': 'multipart/form-data' } }
